import { EventEmitter, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FikoYTArayuz {
  guncelle: EventEmitter<any> = new EventEmitter();
  altBaslik = {
    ismi: "baslik",
    turu: "Yazı",
    degeri: "FikoYT",
    ayarlar: {
      solSimge: "🏡"
    }
  };

  constructor(public readonly router: Router,
    public readonly activatedRoute: ActivatedRoute,
    public readonly title: Title,
  ) {
    this.initBaslikTakip();
  }

  async initBaslikTakip() {
    // if (isPlatformBrowser(inject(PLATFORM_ID))) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd), // Only get the event of NavigationEnd
      map(() => this.activatedRoute), // Listen to activateRoute
      map(route => {
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      }),
      filter(route => route.outlet === 'primary'),
      mergeMap(route => route.data)  // get the data
    ).subscribe((p) => {

      this.altBaslik.degeri = p['baslik'] ?? "FikoYT";
      this.altBaslik.ayarlar!.solSimge = p['simge'] ?? "🏠";
      // console.log(this.altBaslik);

    })
    // }
  }
}
